export function formatCountdown(targetIso) {
  if (!targetIso) return { text: "—", imminent: false, expired: false };
  const target = new Date(targetIso).getTime();
  const now = Date.now();
  const diff = target - now;
  if (diff <= 0)
    return { text: "00:00:00:00", imminent: false, expired: true };
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const mins = Math.floor((diff % 3_600_000) / 60_000);
  const secs = Math.floor((diff % 60_000) / 1000);
  const pad = (n) => String(n).padStart(2, "0");
  return {
    text: `${pad(days)}:${pad(hours)}:${pad(mins)}:${pad(secs)}`,
    imminent: diff < 60_000,
    expired: false,
  };
}

export function formatDateTime(iso, tz) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    ...(tz ? { timeZone: tz } : {}),
  });
}

export function formatTime(iso, tz) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    ...(tz ? { timeZone: tz } : {}),
  });
}

export const REGISTRARS = {
  transip: { label: "TransIP.nl", short: "TRANSIP" },
  spaceship: { label: "Spaceship.com", short: "SPACESHIP" },
  dynadot: { label: "Dynadot", short: "DYNADOT" },
  hostingnl: { label: "Hosting.nl", short: "HOSTING.NL" },
  realtimeregister: { label: "Realtime Register", short: "RTR" },
  openprovider: { label: "Openprovider", short: "OPENPROVIDER" },
  sidn: { label: "SIDN (.nl lookup only)", short: "SIDN" },
};

export const STATUS_STYLES = {
  scheduled: { bg: "#EFF6FF", fg: "#2563EB", label: "SCHEDULED" },
  executing: { bg: "#FFFBEB", fg: "#B45309", label: "FIRING" },
  success: { bg: "#ECFDF5", fg: "#047857", label: "REGISTERED" },
  failed: { bg: "#FFF1F2", fg: "#BE123C", label: "FAILED" },
  cancelled: { bg: "#F4F4F5", fg: "#525252", label: "CANCELLED" },
};
